import firebase from "./firebase"; // Import the initialized Firebase app

class FirebaseMessaging {
  messaging = firebase.messaging();

  async getToken() {
    try {
      const publicUrl = (process.env.PUBLIC_URL || "").replace(/\/$/, "");
      const serviceWorkerRegistration =
        "serviceWorker" in navigator
          ? await navigator.serviceWorker.register(
              `${publicUrl}/firebase-messaging-sw.js`,
              { scope: `${publicUrl}/firebase-messaging/` },
            )
          : undefined;
      const token = await this.messaging.getToken({
        vapidKey:
          "BNycKplks7AZ2V26TkEf4lgcVPvLyYwddrs2Ej_K3hPo6x5rZzkSwJwwqRiVFP95joLO8oe5YhiyPLODmUyXdfk",
        serviceWorkerRegistration,
      });
      return token;
    } catch (error) {
      console.error("Error fetching Firebase token:", error);
    }
  }

  async requestNotificationPermission() {
    try {
      await Notification.requestPermission();
      const token = await this.getToken();
      window.sessionStorage.setItem("fcm", token);
      return token;
    } catch (error) {
      console.error("Error requesting permission:", error);
    }
  }

  onMessage(callback) {
    this.messaging.onMessage(callback);
  }
}

export default new FirebaseMessaging();
